import type { ObservationsBatchEditProps } from "./observations-batch-edit.type";

import BatchEditSelect from "@/modules/batch-edit-select";

import ObservationsBatchEditContent from "./observations-batch-edit-content";
import { useObservationsBatchEditProperties } from "./observations-batch-edit.hook";

const ObservationsBatchEdit = ({
  observations,
}: ObservationsBatchEditProps) => {
  const { properties, currentProperty, setCurrentProperty } =
    useObservationsBatchEditProperties(observations);

  return (
    <div className="observations-batch-edit">
      <BatchEditSelect
        type="observation"
        items={observations}
        properties={properties}
        onPropertyChange={setCurrentProperty}
      />
      <ObservationsBatchEditContent
        property={currentProperty}
        observations={observations}
      />
    </div>
  );
};

export default ObservationsBatchEdit;
